import { createSlice } from '@reduxjs/toolkit';
import BaseError from 'utils/base-error';
import { HomePageState } from './home-page-state';
import { HomePageActions } from './actions';
import {
    createCompanyInformationFromGetCompanyInformationApiResponse,
    createPopularServicesGroupFromGetPopularServicesGroupApiResponse,
} from '../utils';

const initialState: HomePageState = {
    loaded: false,
    errors: [],
};

export const homePageSlice = createSlice({
    name: 'homePageSlice',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(
            HomePageActions.getPopularServicesGroup.fulfilled,
            (state, action) => {
                const response = action.payload;

                if (response instanceof BaseError) {
                    state.errors.push(response);
                } else {
                    try {
                        // eslint-disable-next-line max-len
                        state.popularServicesGroup = createPopularServicesGroupFromGetPopularServicesGroupApiResponse(
                            response.data,
                        );
                    } catch (e) {
                        state.errors.push(new BaseError(400, String(e)));
                    }
                }
            },
        );
        builder.addCase(
            HomePageActions.getCompanyInformation.fulfilled,
            (state, action) => {
                const response = action.payload;

                if (response instanceof BaseError) {
                    state.errors.push(response);
                } else {
                    try {
                        // eslint-disable-next-line max-len
                        state.companyInformation = createCompanyInformationFromGetCompanyInformationApiResponse(
                            response.data,
                        );
                    } catch (e) {
                        state.errors.push(new BaseError(400, String(e)));
                    }
                }
            },
        );
    },
});
